import { useMemo, useState } from 'react';
import Select from './select';

/**
 * Wrapper around `components/select` that always uses `isSearch`.
 * Keeps internal search text state so pages don't have to.
 *
 * `options` can be either:
 * - [{ value, label }]
 * - or any shape, together with `valueKey`/`labelKey`
 */
const SearchableSelect = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  onError,
  options = [],
  valueKey = 'value',
  labelKey = 'label',
  placeholder,
  disabled,
  isLabelIcon,
  iconTitle,
}) => {
  const [searchText, setSearchText] = useState('');

  const safeOptions = useMemo(() => (Array.isArray(options) ? options : []), [options]);

  return (
    <Select
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      onError={onError}
      options={safeOptions}
      valueKey={valueKey}
      labelKey={labelKey}
      isSearch={true}
      searchText={searchText}
      handleSearch={(e) => setSearchText(e.target.value)}
      disabled={disabled}
      isLabelIcon={isLabelIcon}
      iconTitle={iconTitle}
      placeholder={placeholder}
    />
  );
};

export default SearchableSelect;

